import React from 'react';
import {mergeClassnames} from '../../../utils';
import button from './ButtonAction.Button.module.scss';
import link from './ButtonAction.Link.module.scss';
import icon from './ButtonAction.Icon.module.scss';
import reject from './ButtonAction.Reject.module.scss';

type ButtonVariant = 'button' | 'link' | 'icon' | 'reject';
type ComponentCustomClassnames = {
  container: string,
  label: string,
  icon: string,
};

export interface ButtonComponentProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: React.ReactNode,
  icon?: string,
}

export interface StylesButtonComponentProps extends ButtonComponentProps {
  customClassnames: ComponentCustomClassnames;
}

export interface ButtonProps extends ButtonComponentProps {
  variant?: ButtonVariant,
  customClassnames?: Partial<ComponentCustomClassnames>;
}

const ButtonComponent = ({
                           label,
                           icon,
                           customClassnames,
                           ...rest
                         }: StylesButtonComponentProps) => {
  return (
    <button
      type={'button'}
      className={customClassnames.container}
      data-testid={'button-action'}
      {...rest}
    >
      {icon && (
        <img
          src={icon}
          className={customClassnames.icon}
          alt="icon"
        />
      )}
      <div className={customClassnames.label}>{label}</div>
    </button>
  );
};

const ButtonAction = ({
                        variant = 'button',
                        customClassnames = {},
                        ...rest
                      }: ButtonProps) => {
  switch (variant) {
    case 'icon':
      return (
        <ButtonComponent
          customClassnames={mergeClassnames(icon, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
    case 'link':
      return (
        <ButtonComponent
          customClassnames={mergeClassnames(link, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
    case 'reject':
      return (
        <ButtonComponent
          customClassnames={mergeClassnames(reject, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
    case 'button':
    default:
      return (
        <ButtonComponent
          customClassnames={mergeClassnames(button, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
  }
};

export default ButtonAction;
